/**
 * Per-feature icons for discovery cards / checklist / tips.
 * Keeps Tabler icons out of the pure features registry.
 */

'use client'

import type { ComponentType, SVGProps } from 'react'
import {
  IconBooks,
  IconCalendarCheck,
  IconCloudNetwork,
  IconLayoutDashboard,
  IconMicrophone,
  IconPhoto,
  IconSearch,
  IconUsersGroup
} from '@tabler/icons-react'

import type { DiscoverabilityFeatureKey } from '@/lib/discoverability/features'
import { cn } from '@/lib/utils'

const FEATURE_ICONS: Record<
  DiscoverabilityFeatureKey,
  ComponentType<SVGProps<SVGSVGElement> & { size?: number | string }>
> = {
  spaces: IconLayoutDashboard,
  files: IconBooks,
  search: IconSearch,
  planner: IconCalendarCheck,
  images: IconPhoto,
  voice_memos: IconMicrophone,
  connectors: IconCloudNetwork,
  crew: IconUsersGroup
}

export function DiscoverabilityFeatureIcon({
  featureKey,
  className,
  size = 16
}: {
  featureKey: DiscoverabilityFeatureKey
  className?: string
  size?: number
}) {
  const Icon = FEATURE_ICONS[featureKey]
  return <Icon size={size} className={cn('shrink-0', className)} aria-hidden="true" />
}
